import { Application } from "@hotwired/stimulus";
import SwiperController from "./controllers/swiper_controller";
import MasonryController from "./controllers/masonry_controller";
import LightboxController from "./controllers/lightbox_controller";
import FaqController from "./controllers/faq_controller";
import VideoController from "./controllers/video_controller";
import FacetsController from "./controllers/facets_controller";
import DropdownController from "./controllers/dropdown_controller";
import BurgerController from "./controllers/burger_controller";
import MenuController from "./controllers/menu_controller";
import MenuMobileController from "./controllers/menu-mobile_controller";
import TabsController from "./controllers/tabs_controller";
import CourseAnchorsController from "./controllers/course-anchors_controller";
import CartController from "./controllers/cart_controller";
import ShareController from "./controllers/share_controller";
import CourseAsideController from "./controllers/course-aside_controller";
import FiltersController from "./controllers/filters_controller";
import CalculatorController from "./controllers/calculator_controller";
import CalendarController from "./controllers/calendar_controller";
import VariationPreselectController from "./controllers/variation-preselect_controller";

//import utils from './utils';

export default class App {
  initCore() {
    window.Stimulus = Application.start();
    Stimulus.register("swiper", SwiperController);
    Stimulus.register("masonry", MasonryController);
    Stimulus.register("lightbox", LightboxController);
    Stimulus.register("faq", FaqController);
    Stimulus.register("video", VideoController);
    Stimulus.register("facets", FacetsController);
    Stimulus.register("dropdown", DropdownController);
    Stimulus.register("burger", BurgerController);
    Stimulus.register("menu", MenuController);
    Stimulus.register("menu-mobile", MenuMobileController);
    Stimulus.register("tabs", TabsController);
    Stimulus.register("course-anchors", CourseAnchorsController);
    Stimulus.register("cart", CartController);
    Stimulus.register("share", ShareController);
    Stimulus.register("filters", FiltersController);
    Stimulus.register("course-aside", CourseAsideController);
    Stimulus.register("calculator", CalculatorController);
    Stimulus.register("calendar", CalendarController);
    Stimulus.register("variation-preselect", VariationPreselectController);

    function onYouTubeIframeAPIReady() {
      window.dispatchEvent(new CustomEvent('yt:ready'));
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
  }
}

function LoadApp() {
  const app = new App();
  app.initCore(); // runs on initialize
}

if (document.readyState === 'loading') { 
  document.addEventListener('DOMContentLoaded', LoadApp);
} else { 
  LoadApp();
}
